
define('text!modules/shared/templates/list.html',[],function () { return '<dl class="w-itemList">\n    <dt class="title">{{{title}}}</dt>\n    <dd>\n        <div class="list">\n            {{#list}}\n            {{>item}}\n            {{/list}}\n        </div>\n    </dd>\n</dl>';});

